import clsx from "clsx";
import classes from "./styles.module.scss";

function SkillsterIcon({
  size,
  borderColor,
  backgroundColor,
}: {
  size?: number;
  borderColor?: string;
  backgroundColor?: string;
}) {
  return (
    <div className={classes.starBorderContainer}>
      <div className={classes.borderGradientBottom} />
      <div className={classes.borderGradientTop} />
      <svg
        width={size ?? 46}
        height={size}
        viewBox="0 0 46 46"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ zIndex: 1 }}
      >
        <path
          d="M3.17236 10.7664C3.17236 6.5726 6.57211 3.17285 10.7659 3.17285H35.234C39.4278 3.17285 42.8275 6.5726 42.8275 10.7664V35.2345C42.8275 39.4283 39.4278 42.828 35.234 42.828H10.7659C6.57211 42.828 3.17236 39.4283 3.17236 35.2345V10.7664Z"
          fill={backgroundColor ?? "#3A5082"}
        />
        <path
          d="M32.8428 22.5684L22.5674 32.8428L12.293 22.5684L22.5674 12.293L32.8428 22.5684ZM21.9922 18.8809C21.3532 18.8809 20.8086 18.9469 20.3584 19.0791C19.9082 19.2113 19.5375 19.3983 19.2471 19.6406C18.9639 19.8756 18.7567 20.1545 18.626 20.4775C18.4953 20.7932 18.4307 21.1384 18.4307 21.5127C18.4307 22.0487 18.6229 22.4787 19.0078 22.8018C19.3926 23.1248 19.9986 23.2861 20.8262 23.2861H24.1777C24.6352 23.2861 24.8643 23.4338 24.8643 23.7275C24.8642 23.9403 24.7951 24.0984 24.6572 24.2012C24.5193 24.3038 24.2978 24.3545 23.9932 24.3545H19.9893L17.6533 26.249H23.4814C24.1276 26.249 24.6758 26.1829 25.126 26.0508C25.5833 25.9113 25.9542 25.7208 26.2373 25.4785C26.5275 25.229 26.7375 24.9351 26.8682 24.5977C26.9988 24.26 27.0644 23.8925 27.0645 23.4961C27.0645 22.9454 26.8573 22.53 26.4434 22.251C26.0367 21.9648 25.4378 21.8213 24.6465 21.8213H21.3057C20.8413 21.8212 20.6086 21.6821 20.6084 21.4033C20.6084 21.1832 20.6776 21.0286 20.8154 20.9404C20.9534 20.845 21.1755 20.7969 21.4805 20.7969H24.459L26.2451 18.8809H21.9922Z"
          fill="white"
        />
      </svg>
    </div>
  );
}

export default SkillsterIcon;
